<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col">
        <div class="row pb-3">
          <div class="col"><h5>All Projects</h5></div>
          <div class="col text-right" v-if="user.email_verified">
            <i v-if="creating" class="fas fa-spinner fa-spin fa-1x"></i>
            <div v-else>
              <div class="d-none d-md-table col pr-3"><a href="/projects/new" class="highlight">Start New Project</a></div>
              <div class="pr-3"><a href="/projects/new" class="d-md-none"><i class="fa-solid fa-circle-plus fa-2x debit"></i></a></div>
            </div>
          </div>
        </div>

    <div class="card" v-if="!user.email_verified">
      <div class="card-body">
        <p class="text-center mb-0">Please <a href="/verify-email" class="highlight">verify your email</a> then you can start a new project</p>
      </div>
    </div>

       <b-card no-body v-else>
      <b-tabs v-model="tabIndex" card align="center">
        <b-tab title="Waiting for quote" title-link-class="darklink">
          <b-card-text><admin-projects-list :status="0" :user="user" ref="AdminProjects"></admin-projects-list></b-card-text>
        </b-tab>
        <b-tab title="Quote received" title-link-class="darklink">
          <b-card-text><admin-projects-list :status="1" :user="user" ref="AdminProjects"></admin-projects-list></b-card-text>
        </b-tab>
        <b-tab title="In progress" title-link-class="darklink">
          <b-card-text><admin-projects-list :status="2" :user="user" ref="AdminProjects"></admin-projects-list></b-card-text>
        </b-tab>
        <b-tab title="Waiting for review" title-link-class="darklink">
          <b-card-text><admin-projects-list :status="3" :user="user" ref="AdminProjects"></admin-projects-list></b-card-text>
        </b-tab>
        <b-tab title="Completed" title-link-class="darklink">
          <b-card-text><admin-projects-list :status="4" :user="user" ref="AdminProjects"></admin-projects-list></b-card-text>
        </b-tab>
      </b-tabs>
    </b-card>
        
      </div>
    </div>
  </div>
</template> 

<script>
export default {
  props: ['user'],

  data() {
    return {
      tabIndex: 0,
      creating: false,
    };
  },

  methods: {
    completeProfile() {
      this.sweetfire(
        "Please complete your profile then you can create a project"
      );
    },

    sweetfire(text) {
      Swal.fire({
        title: text,
        html: '<a href="/profile" target="_self" class="btn btn-success">Complete profile</a>',
        showConfirmButton: false,
        showDenyButton: false,
        showCancelButton: false,
        focusConfirm: false,
        cancelButtonText: "Ok",
        customClass: {
          title: "popup-title",
        },
      });
    },

  },
};
</script>